export enum Partners {
  DEFAULT,
  LSOS,
  PEOPLE_SOLUTIONS,
  NORWAY,
  ACCA,
  PNC,
  CONSTRUCTION,
  ACCA_OVER,
  ENW = 9,
  REGULATORY,
  NORWAY_PI,
  LSOS_ADDON,
  RPA,
  PERFORMANCE,
  PNC_RETAIL,
  TEST = 1000,
}

export const partnersMeta = {
  [Partners.LSOS]: {
    icon: 'lsos',
  },
};
